import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../generated/graphql";
import { useAuth } from "../contexts/AuthContext";

const LoginPage: React.FC = () => {
  const [printCode, setPrintCode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  const [loginMutation, { loading }] = useLoginMutation();

  const handlePrintCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // 6文字以内に制限
    const value = e.target.value;
    if (value.length <= 6) {
      setPrintCode(value);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!printCode) {
      setError("印刷コードを入力してください");
      return;
    }

    try {
      const result = await loginMutation({
        variables: {
          input: {
            printCode,
          },
        },
      });

      if (result.data?.login?.errors && result.data.login.errors.length > 0) {
        const errorMessage = result.data.login.errors[0].message;
        setError(errorMessage || "ログインに失敗しました");
        return;
      }

      // 認証情報が返ってきた場合
      if (result.data?.login?.authentication) {
        const { token, printOffice } = result.data.login.authentication;

        // コンテキストに認証情報を保存
        login({
          token,
          printOffice: {
            id: printOffice.id,
            name: printOffice.name,
            officeCode: printOffice.officeCode,
            printCode: printOffice.printCode,
          },
        });

        // ホームページに遷移
        navigate("/");
      } else {
        setError("ログインに失敗しました");
      }
    } catch (err) {
      setError("ログイン処理中にエラーが発生しました");
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* ヘッダー */}
      <header className="bg-primary h-[111px] flex items-center justify-center shadow-md">
        <div className="flex items-center justify-center">
          <img
            src="/logo_dailytry.svg"
            alt="ロゴ"
            className="h-8 w-auto mr-3"
          />
          <h2 className="text-heading-2 text-white font-semibold">
            プリントジョブ
          </h2>
        </div>
      </header>

      {/* コンテンツエリア */}
      <main className="flex-grow flex items-center justify-center bg-white p-6">
        <div className="w-full max-w-md">
          <h1 className="text-heading-1 font-bold text-center mb-6">
            ログイン
          </h1>

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-6 flex flex-col items-center">
              <label
                htmlFor="printCode"
                className="block text-gray-700 mb-2 font-bold self-start ml-[calc(50%-181px)]"
              >
                印刷コード
              </label>
              <input
                id="printCode"
                type="text"
                value={printCode}
                onChange={handlePrintCodeChange}
                maxLength={6}
                className="w-[362px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary shadow-[inset_0px_1px_1px_rgba(0,0,0,0.1)] bg-[#F3F3F3]"
                placeholder="教室に記載の6ケタを入力"
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              className={`w-[362px] h-12 bg-primary text-white font-semibold py-2 px-4 rounded-md transition duration-200 mx-auto block ${
                loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
              disabled={loading}
            >
              {loading ? "ログイン中..." : "ログイン"}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
